<template>
  <div>
    <div class="upload-box">
      <el-upload
        action
        list-type="picture-card"
        :before-upload="beforeUpload"
        :on-progress="onProgressUpload"
        :limit="totalLimit"
        :on-success="handleSuccess"
        ref="upload"
        :show-file-list="false"
        :multiple="isMultiple"
      >
        <i slot="default" class="el-icon-plus"></i>
      </el-upload>
      <div class="preview-box">
        <!-- 调试代码，勿删 -->
        <!-- <div class="item">
          <span class="hover-cover"></span>
          <i class="el-icon-delete icon"></i>
        </div>
        <div class="item">
          <span class="hover-cover"></span>
          <i class="el-icon-delete icon"></i>
        </div>
        <div class="item">
          <span class="hover-cover"></span>
          <i class="el-icon-delete icon"></i>
        </div>
        <div class="item">
          <span class="hover-cover"></span>
          <i class="el-icon-delete icon"></i>
        </div> -->
        <div v-for="(item, index) in ossList" :key="index" class="item">
          <el-image :src="ossList[index]" :preview-src-list="ossList" class="preview-image"> </el-image>
          <span class="hover-cover"></span>
          <i class="el-icon-delete icon" @click="deleteImage(index)"></i>
        </div>
      </div>
    </div>
    <div class="upload-alert">上传图片只能是 JPG/PNG 格式，且不能超过{{ sizeLimit }}MB</div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "ossUploader",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      uploadValid: false,
      file: "",
      fileList: [],
      ossList: []
    };
  },
  props: {
    sizeLimit: {
      type: Number,
      default: 1
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    totalLimit: {
      type: Number,
      default: 1
    },
    validFormat: {
      type: Array,
      default: () => ["image/jpeg", "image/png"]
    },
    previewList: {
      type: Array,
      default: () => []
    }
  },

  mounted() {},

  watch: {
    previewList: {
      immediate: true,
      handler(val) {
        this.ossList = JSON.parse(JSON.stringify(val));
      }
    }
  },

  methods: {
    beforeUpload(file) {
      // this.file = file;
      if (this.ossList.length >= this.totalLimit) {
        this.$message.error(`最多上传${this.totalLimit}张图片!`);
        return false;
      }
      const isValidPic = file.type === "image/jpeg" || file.type === "image/png";
      const isLt = file.size / 1024 / 1024 < this.sizeLimit;

      if (!isValidPic) {
        this.$message.error(`上传图片只能是 JPG/PNG 格式!`);
      }
      if (!isLt) {
        this.$message.error(`上传图片大小不能超过${this.sizeLimit}MB!`);
      }
      this.uploadValid = isValidPic && isLt;
      return isValidPic && isLt;
    },
    /**
     * @description: 自定义上传
     * @param {*}
     * @return {*}
     */
    onProgressUpload(e, file) {
      const params = new FormData();
      params.append("file", file.raw);
      params.append("path", "upload/common");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, {
        "Content-Type": "multipart/form-data"
      })
        .then((res) => {
          this.uploading = false;
          this.ossList.push(res.data);
          if (this.isMultiple) {
            this.$emit("setImage", this.ossList);
          } else {
            this.$emit("setImage", this.ossList[0]);
          }
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * @description: 上传成功事件，清空缓存中的fileList才能多次上传
     * @param {*} res
     * @param {*} file
     * @return {*}
     */
    handleSuccess() {
      this.$refs.upload.clearFiles();
    },
    /**
     * @description: 删除图片
     * @param {*} index
     * @return {*}
     */
    deleteImage(index) {
      this.ossList.splice(index, 1);
      if (this.isMultiple) {
        this.$emit("setImage", this.ossList);
      } else {
        this.$emit("setImage", this.ossList[0]);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.upload-box {
  display: flex;
  .preview-box {
    flex-wrap: wrap;
    display: flex;
    margin-left: 10px;
    .item {
      max-width: 148px;
      max-height: 148px;
      cursor: pointer;
      margin-bottom: 10px;
      margin-right: 10px;
      position: relative;
      .preview-image {
        max-width: 100%;
        max-height: 100%;
        border-radius: 6px;
      }
      .hover-cover {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.5);
      }
      .icon {
        display: none;
        position: absolute;
        font-size: 30px;
        color: #fff;
        top: 50%;
        left: 50%;
        margin-top: -15px;
        margin-left: -15px;
      }
    }
    .item:hover .hover-cover {
      display: block;
    }
    .item:hover .icon {
      display: block;
    }
  }
}
.upload-alert {
  font-size: 14px;
  color: #ee7942;
}
</style>
